import { z } from 'zod';
import { ORDERS_TABLE_STATUS } from '~/constants';
// import { transformNullToEmptyString } from '~/utils';

const transformNullToEmptyString = (val: string | null) => val || '';
const ShopifyOrdersApprovalSchema = z.object({
  id: z.string(),
  code: z.string().nullable().transform(transformNullToEmptyString),
  documentPath: z.string().url(),
  doctorName: z.string().nullable().transform(transformNullToEmptyString)
});
type ShopifyOrdersApprovalType = z.infer<typeof ShopifyOrdersApprovalSchema>;

const ShopifyOrdersPharmacySchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string(),
  phone: z.string().optional()
});
type ShopifyOrdersPharmacyType = z.infer<typeof ShopifyOrdersPharmacySchema>;

const ShopifyOrdersProductSchema = z.object({
  name: z.string(),
  sku: z.string()
});
type ShopifyOrdersProductType = z.infer<typeof ShopifyOrdersProductSchema>;

const ShopifyOrdersItemSchema = z.object({
  id: z.string(),
  object: z.literal('supplier-order-item'),
  status: z.enum(ORDERS_TABLE_STATUS),
  createdDate: z.string().datetime(),
  quantity: z.number(),
  approval: ShopifyOrdersApprovalSchema,
  pharmacy: ShopifyOrdersPharmacySchema,
  product: ShopifyOrdersProductSchema
});
type ShopifyOrdersItemType = z.infer<typeof ShopifyOrdersItemSchema>;

const ShopifyOrdersDataResponseSchema = z.object({
  meta: z.object({
    total: z.number(),
    page: z.number(),
    size: z.number()
  }),
  data: z.array(ShopifyOrdersItemSchema)
});
type ShopifyOrdersDataResponseType = z.infer<typeof ShopifyOrdersDataResponseSchema>;

export {
  ShopifyOrdersApprovalSchema,
  ShopifyOrdersDataResponseSchema,
  ShopifyOrdersItemSchema,
  ShopifyOrdersPharmacySchema,
  ShopifyOrdersProductSchema
};
export type {
  ShopifyOrdersApprovalType,
  ShopifyOrdersDataResponseType,
  ShopifyOrdersItemType,
  ShopifyOrdersPharmacyType,
  ShopifyOrdersProductType
};
